import { useState } from 'react';

import { MDText } from 'i18n-react';

import { ArrowRightIcon, IconText, VerifiedIcon } from '@motorway/mw-highway-code';
import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { POST_SALE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsPostSale';

import { DealershipDetailsModal } from '../../../documentCapture/DealerDetails/DealershipDetailsModal/DealershipDetailsModal';
import { useSaleDetailsSub } from '../../hooks/useSaleDetailsSub';

import Texts from './DealerDetails.texts.json';

import styles from './DealerDetails.scss';

const LocalT = new MDText(Texts);

export const DealerDetails = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const {
    dealershipName,
    dealershipPhone,
    email,
  } = useSaleDetailsSub();

  if (!dealershipName) {
    return null;
  }

  const onOpenModal = () => {
    setOpenModal(true);

    POST_SALE_SNOW_PLOW_EVENTS.DEALER_DETAILS_MODAL_OPENED(dealershipName);
  };

  const onCloseModal = () => {
    setOpenModal(false);

    POST_SALE_SNOW_PLOW_EVENTS.DEALER_DETAILS_MODAL_CLOSED({ dealer: dealershipName });
  };

  const dealerLinkContent = <div className={styles.dealerLinkText}>
    <span className={styles.dealerName}>
      {dealershipName}
    </span>
    <span className={styles.viewDetails}>
      {LocalT.translate('viewDetails')}
    </span>
  </div>;

  const linkContent = <>
    <IconText
      icon={VerifiedIcon}
      text={dealerLinkContent}
      variant='small--regular' />
    <span className={styles.chevron}>
      <ArrowRightIcon />
    </span>
  </>;

  return (
    <div className={styles.dealerDetails}>
      <h2 className={styles.title}>{LocalT.translate('purchasingDealer')}</h2>
      <div className={styles.dealerLink}>
        <Hyperlink label={linkContent} onClick={onOpenModal} underline={false} variant='secondary'/>
      </div>
      {openModal && (
        <DealershipDetailsModal
          dealership={{ contactEmail: email, contactNumber: dealershipPhone, name: dealershipName }}
          onCloseModalClick={onCloseModal}
        />
      )}
    </div>
  );
};
